import React from "react"
import { Box } from "@mui/material"

// Helper: convert Strapi JSON to HTML
const richTextToHtml = (content, maxLength) => {
  if (!content) return ""

  // Extract plain text
  let text = ""

  if (typeof content === "string") {
    text = content.replace(/<[^>]+>/g, "")
  } else if (Array.isArray(content)) {
    text = content
      .map((block) =>
        block.type === "paragraph"
          ? block.children.map((child) => child.text || "").join(" ")
          : ""
      )
      .join(" ")
  }

  // Apply truncation ONLY if maxLength is provided
  if (maxLength && text.length > maxLength) {
    text = text.slice(0, maxLength) + "..."
  }

  return `<p>${text}</p>`
}

const RichTextRenderer = ({ content, maxLength }) => {
  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <div
        dangerouslySetInnerHTML={{
          __html: richTextToHtml(content, maxLength),
        }}
      />
    </Box>
  )
}

export default RichTextRenderer
